import { getObservableById, setObservableById } from './helper';

export const isLoading$ = new Map();

export const getIsLoading$ = (compId: string) =>
  getObservableById(isLoading$, compId, true);

export const setIsLoading$ = (value: boolean, compId: string) =>
  setObservableById(isLoading$, value, compId);
